import React, { createContext, useEffect, useState } from "react";
import Button1 from "../../../../components/form/Button1";
import { Modal3 } from "../../../../components/DIsplay/Modal/Modal3";
import AirlinesInput from "../../../../components/form/AirlinesInput";
import TextInput from "../../../../components/form/TextInput";
import CustomTable from "../../../../components/Table/CustomTable";
import createAirlineCommission from "../../../../controllers/settings/AirlineCommission/createAirlineCommission";
import { enqueueSnackbar } from "notistack";
import getAirlineCommissions from "../../../../controllers/settings/AirlineCommission/getAirlineCommissions";
import Icon from "../../../../components/HOC/Icon";
import AirlineCommissionForm from "./AirlineCommissionForm";
import AirlineCommissionDelete from "./AirlineCommissionDelete";
import useAccount from "../../../../hooks/useAccount";
import Unauthorized from "../../../../components/DIsplay/Unauthorized";

const ActionContext = createContext();

export default function AirlineCommission() {
  const [paginationModel, setPaginationModel] = React.useState({
    page: 0,
    pageSize: 20,
    rowCount: 0,
  });
  const [data, setData] = useState([]);
  const [openEdit, setOpenEdit] = useState(false);
  const [openRemove, setOpenRemove] = useState(false);
  const [loadings, setLoadings] = useState({ load: false });

  const { checkPermission } = useAccount();

  useEffect(() => {
    load();
  }, []);

  async function load() {
    setLoadings({ ...loadings, load: true });
    const res = await getAirlineCommissions();
    setLoadings({ ...loadings, load: false });
    if (res?.return) {
      setData(res?.data?.data);
    }
  }

  console.log(data, openRemove, openEdit);

  const columns = [
    { field: "airline", headerName: "Airline Code", flex: 1 },
    { field: "name", headerName: "Airline Name", flex: 1 },
    { field: "commission", headerName: "Commission", flex: 1 },
    {
      field: "action",
      headerName: "Action",
      flex: 1,
      renderCell: (params) => <ActionCol {...{ params, reload: load }} />,
    },
  ];

  if (!checkPermission("read:airline-commission")) return <Unauthorized />;

  return (
    <div className="flex flex-col gap-4">
      {checkPermission(["create:airline-commission"]) && (
        <CreateCommission reload={() => load()} />
      )}
      <ActionContext.Provider
        value={{
          remove: (data) => setOpenRemove(data),
          edit: (data) => setOpenEdit(data),
        }}
      >
        <CustomTable
          loading={loadings?.load}
          rows={data}
          columns={columns}
          // searchProps={{
          //     searchable: true,
          //     search: setSearchValue,
          // }}
          rowCount={paginationModel?.rowCount}
          paginationMode="server"
          paginationModel={paginationModel}
          onPaginationModelChange={setPaginationModel}
        />
      </ActionContext.Provider>
      {checkPermission("update:airline-commission") && (
        <Modal3
          title="Update Airline Commission"
          open={openEdit}
          setOpen={() => setOpenEdit(false)}
        >
          <AirlineCommissionForm
            data={openEdit}
            close={() => setOpenEdit(false)}
            callback={() => load()}
          />
        </Modal3>
      )}
      {checkPermission("update:airline-commission") && (
        <Modal3
          title="Remove Airline Commission"
          open={openRemove}
          setOpen={() => setOpenRemove(false)}
        >
          <AirlineCommissionDelete
            id={openRemove?._id}
            close={() => setOpenRemove(false)}
            callback={() => load()}
          />
        </Modal3>
      )}
    </div>
  );
}

function ActionCol({ params }) {
  const { checkPermission } = useAccount();

  return (
    <div>
      <ActionContext.Consumer>
        {(value) => {
          const { edit, remove } = value || {};
          return (
            <div className="flex gap-4 items-center">
              {checkPermission(["update:airline-commission"]) && (
                <Button1
                  className="!min-w-[40px] !px-2 !bg-secondary !shadow !text-theme1"
                  onClick={() => edit && edit(params?.row)}
                >
                  <Icon icon="mdi:edit" />
                </Button1>
              )}
              {checkPermission([
                "update:airline-commission",
                "delete:airline-commission",
              ]) ? (
                <Button1
                  className="!min-w-[40px] !px-2 !bg-red-500"
                  onClick={() => remove && remove(params?.row)}
                >
                  <Icon icon="mdi:delete" />
                </Button1>
              ) : null}
            </div>
          );
        }}
      </ActionContext.Consumer>
    </div>
  );
}

function CreateCommission({ reload }) {
  const [openCreate, setOpenCreate] = useState(false);

  return (
    <div>
      <div className="flex justify-between gap-4">
        <div></div>
        <div>
          <Button1 onClick={() => setOpenCreate(true)}>
            Create Commission
          </Button1>
        </div>
      </div>

      <Modal3
        title={"Create Airline Commission"}
        open={openCreate}
        setOpen={() => setOpenCreate(false)}
      >
        <AirlineCommissionForm
          close={() => setOpenCreate(false)}
          callback={() => reload()}
        />
      </Modal3>
    </div>
  );
}
